import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { SelectionItem } from './select.component';
import { MatSelectChange } from '@angular/material/select';

@Component({
    selector: 'app-select-freeform',
    templateUrl: './select-freeform.component.html',
    styleUrls: ['./select-freeform.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SelectFreeformComponent<TValue = any> {
  @Input() itemsSource: SelectionItem<TValue>[] = [];
  @Input() multiple: boolean = false;
  @Input() placeholder: string = '';
  @Input() errorMessage: string;
  @Input() isReadonly: boolean = false;
  // Supports both single-select (scalar) and multi-select (array) usage, mirroring
  // mat-select's [multiple] behaviour, hence the TValue | TValue[] unions.
  @Input() set initialValues(values: TValue | TValue[]) {
    this.selectedValues = values !== undefined && values !== null ? values : [];
  }
  @Output() valueChange = new EventEmitter<TValue | TValue[]>();

  selectedValues: TValue | TValue[] = [];

  handleSelectionChange(event: MatSelectChange): void {
    this.valueChange.emit(this.selectedValues);
  }
}
